import { render, staticRenderFns } from "./customerDialog.vue?vue&type=template&id=238a0bdb&scoped=true"
import script from "./customerDialog.vue?vue&type=script&lang=js"
export * from "./customerDialog.vue?vue&type=script&lang=js"
import style0 from "./customerDialog.vue?vue&type=style&index=0&id=238a0bdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238a0bdb",
  null
  
)

export default component.exports